import { Divider, Typography } from "@mui/material"
import type { ReactElement } from "react"

import { AerosRadioGroup } from "@/components/UiKit"
import type { Option } from "@/types/form-fields"

interface InventoryFilterRadioGroupProps<T extends string> {
  label: string
  value: T
  options: Option<T>[]
  onChange: (value: T) => void
  testIdPrefix: string
}

export const InventoryFilterRadioGroup = <T extends string>({
  label,
  value,
  options,
  onChange,
  testIdPrefix,
}: InventoryFilterRadioGroupProps<T>): ReactElement => (
  <div data-testid={testIdPrefix}>
    <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
      {label}
    </Typography>
    <Divider className='mb-4' />
    <div className='px-4'>
      <AerosRadioGroup options={options} value={value} onChange={onChange} data-testid={`${testIdPrefix}.group`} />
    </div>
  </div>
)
